import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import * as NotificationsActions from './notifications.actions';
import { NotificationsService } from '../services/notifications.service';
import { NotificationsResponse } from '../interfaces/notifications.interface';

@Injectable()
export class NotificationsEffects {
  loadUsers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationsActions.loadNotifications),
      mergeMap(() =>
        this._notificationsService.getMyUserNotifications().pipe(
          map((response: NotificationsResponse) => {
            return NotificationsActions.loadNotificationsSuccess({ response });
          }),
          catchError((error) =>
            of(NotificationsActions.loadNotificationsError({ error }))
          )
        )
      )
    );
  });

  eventTypeLoad$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationsActions.loadEventTypeLoadNotification),
      mergeMap((action) =>
        this._notificationsService.setEventLoad(action.notificationId).pipe(
          map(() => {
            return NotificationsActions.loadEventTypeLoadNotificationSuccess();
          })
        )
      )
    );
  });

  eventTypeDismiss$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationsActions.loadEventTypeDismissNotification),
      mergeMap((action) =>
        this._notificationsService
          .setEventDismissed(action.notificationId)
          .pipe(
            map(() => {
              return NotificationsActions.loadEventTypeDismissNotificationSuccess();
            })
          )
      )
    );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly _notificationsService: NotificationsService
  ) { }
}
